import React, { useEffect, useState } from "react";
import Profile from "scenes/profile";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { useGetStudentsQuery } from "state/api";
import Header from "components/Header";
import { useSelector } from "react-redux";
import { RootState } from "state";
import StudentsGrid from "components/StudentsGrid";

const StudentsPage = () => {
    const [skip, setSkip] = useState(true);
    const { schoolId, schoolName } = useSelector(
        (state: RootState) => state.admin
    );

    const [id, setId] = useState(0);
    const [name, setName] = useState("");
    const { user } = useSelector((state: RootState) => state.auth);
    
    useEffect(() => {
        if (user && user.isAdmin && schoolId > 0) {
            console.log("School Id: ", schoolId);
            setSkip(false);
            setId(schoolId);
            if (schoolName) {
                setName(schoolName);
            }
        }
       else if (user && user.school_id > 0) {
            setSkip(false);
            setId(user.school_id);
            if (user.school_name) {
                setName(user.school_name);
            }
        }
    }, [schoolId, schoolName, user]);   
  
    const { data: studentsData, isLoading: isStudentsDataLoading } =
        useGetStudentsQuery(Number(schoolId > 0 ? schoolId : user?.school_id), {
            skip,
        });
  const isNonMobile = useMediaQuery("(min-width: 600px)");

  return (
    <Box m="1.5rem 2.5rem">
          <Header title="Students" subtitle={schoolName || ""} />
      <StudentsGrid
        data={studentsData}
        isLoading={isStudentsDataLoading}
        displayHeader={false}
      />
    </Box>
  );
};

export default StudentsPage;
